<template>
  <b-modal id="bv-modal-example" no-close-on-backdrop hide-footer>
    <template #modal-title> Санамж </template>
    <div class="d-block text-center">
      <h3>Нэвтэрч орсоноос хойш 30 минут болсон байна</h3>
    </div>
    <b-button class="mt-3" block @click="cancel">хаах</b-button>
  </b-modal>
</template>

<script>
export default {
  data: () => {
    return {
      timerCount: "",
    };
  },
  methods: {
    cancel: function () {
      this.$bvModal.hide("bv-modal-example");
      this.timerCount = 1800;
    },
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
            localStorage.setItem("memento", this.timerCount);
          }, 1000);
        } else if (value === 0) {
          this.$bvModal.show("bv-modal-example");
        }
      },
      immediate: true,
    },
  },

  mounted() {
    this.timerCount = parseInt(localStorage.getItem("memento"));
  },
};
</script>

<style scoped></style>
